export default "__VITE_ASSET__449Ez10a__"